export const isSwedenCountryCodeOrUndefined = countryCodeIso2 =>
    countryCodeIso2 === undefined ||
    countryCodeIso2 === null ||
    countryCodeIso2.toLowerCase() === 'se';

export const isSwedenCountryNameOrUndefined = countryName =>
    countryName === undefined ||
    countryName === null ||
    countryName.toLowerCase() === 'sweden';
